import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { fadeUp } from "../../../lib/motion";

export default function SecureFamilySection() {
  return (
    <section className="py-24 sm:py-32 bg-white" data-testid="secure-family-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="rounded-[32px] bg-[#011233] text-white overflow-hidden grid lg:grid-cols-12">
          <motion.div
            {...fadeUp}
            className="lg:col-span-7 p-10 sm:p-14 flex flex-col justify-center"
          >
            <p className="text-[12px] uppercase tracking-[0.36em] text-[#B5BAC2] font-semibold">
              Why Knight
            </p>
            <h2 className="mt-5 font-heading font-bold text-3xl sm:text-5xl lg:text-6xl leading-[1.04] tracking-tight">
              Secure your family
              <br />
              and your future with
              <br />
              <span className="text-[#B5BAC2]">Knight Insurance Solutions.</span>
            </h2>
            <p className="mt-6 text-[15px] sm:text-base text-white/85 max-w-xl leading-relaxed">
              One conversation. Multiple carriers. The right coverage at the right
              price — designed around how you actually live.
            </p>
            <div className="mt-9">
              <a
                href="#quote"
                className="inline-flex items-center gap-2 rounded-full bg-white text-[#011233] px-7 py-3.5 text-base font-semibold hover:bg-[#B5BAC2] transition-all"
                data-testid="secure-family-cta"
              >
                Request your quote
                <ArrowRight size={18} />
              </a>
            </div>
          </motion.div>
          <motion.div
            initial={fadeUp.initial}
            whileInView={fadeUp.whileInView}
            viewport={fadeUp.viewport}
            transition={{ ...fadeUp.transition, delay: 0.1 }}
            className="lg:col-span-5 relative min-h-[280px]"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_modern-knight-ins/artifacts/bwnwnurc_auto.jpg"
              alt="Family"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-l from-transparent via-transparent to-[#011233]/35" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
